import { useFirebaseUser } from "./useFirebaseUser.shared";
import { useSellarUser } from "./useSellarUser.shared";

export const useIsSellarAdmin = (): boolean => {
  const { user: firebaseUser } = useFirebaseUser();
  const { user: sellarUser } = useSellarUser();

  return firebaseUser?.isAdmin === true || sellarUser?.type === "admin";
};
